import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-[#FDF6EE] text-stone-800 py-24 px-4" data-id="element-47">
      <div className="max-w-4xl mx-auto" data-id="element-48">
        <FadeIn data-id="element-49">
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl border-2 border-amber-500/30 relative overflow-hidden text-center" data-id="element-50">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-2 bg-gradient-to-r from-amber-400 via-amber-500 to-amber-600" data-id="element-51" />

            <div className="inline-flex items-center justify-center p-4 bg-amber-100 rounded-full mb-8" data-id="element-52">
              <ShieldCheck className="w-12 h-12 text-amber-600" data-id="element-53" />
            </div>

            <div className="inline-block px-4 py-1 bg-amber-100 text-amber-800 text-sm font-bold rounded-full uppercase tracking-widest mb-6" data-id="element-54">
              21 días de garantía
            </div>

            <h2 className="text-3xl md:text-4xl font-black mb-6 text-stone-900" data-id="element-55">
              Garantía Total: Si No Funciona, No Pagas
            </h2>

            <p className="text-xl text-stone-600 leading-relaxed max-w-3xl mx-auto" data-id="element-56">
              Estamos tan seguros de que este método va a cambiar tus mañanas
              que te damos una garantía simple: Si después de seguir el
              protocolo LSA durante 21 días no sientes una mejora real en tu
              movilidad y dolor articular, te devolvemos cada centavo. Sin
              preguntas, sin complicaciones.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}